import { find, get, isEmpty } from 'lodash';

import {
  PRICE_UNAVAILABLE,
  determineProductOrVariantPricing,
  isPriceUnavailable
} from 'app/product/utils/PricingUtils';

/**
 * Determines the pricing for a list item, using its selected variant's pricing
 * when it has one. Returns {@link PRICE_UNAVAILABLE} when the item has no
 * pricing at all.
 *
 * @param {{}} listItem
 * @return {{}}
 */
function determineListItemPricing(listItem) {
  const {
    itemSkuRef: { sku: itemSku, variantId },
    product
  } = listItem;
  const selectedVariant = find(get(product, 'variants'), ({ id, sku }) => {
    return id === variantId || sku === itemSku;
  });
  const selectedVariantPricing = determineProductOrVariantPricing(
    selectedVariant,
    get(selectedVariant, 'priceInfo')
  );
  const pricing = isEmpty(selectedVariantPricing)
    ? determineProductOrVariantPricing(product, get(product, 'priceInfo'))
    : selectedVariantPricing;

  return isEmpty(pricing) ? PRICE_UNAVAILABLE : pricing;
}

/**
 * Whether a list item has no price, so it shows "Call for Pricing" and cannot
 * be added to the cart.
 *
 * @param {{}} listItem
 * @return {boolean}
 */
function isListItemPriceUnavailable(listItem) {
  return isPriceUnavailable(determineListItemPricing(listItem));
}

export { determineListItemPricing, isListItemPriceUnavailable };
